/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Fix_Fdc_LinkedInputs */

const en_fix_fdc_linked = /** @type {(inputs: Fix_Fdc_LinkedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Linked to USDA food ${i?.id}.`)
};

const de_fix_fdc_linked = /** @type {(inputs: Fix_Fdc_LinkedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mit USDA-Lebensmittel ${i?.id} verknüpft.`)
};

/**
* | output |
* | --- |
* | "Linked to USDA food {id}." |
*
* @param {Fix_Fdc_LinkedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_fdc_linked = /** @type {((inputs: Fix_Fdc_LinkedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_Fdc_LinkedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_fdc_linked(inputs)
	return en_fix_fdc_linked(inputs)
});